import React, { useState } from 'react'
import { Typography, TextBox } from '@telavita-core/react-design-kit'
import { ReactComponent as IconHelp } from 'static/svg/icon-help.svg'

import * as S from './styles'
import ModalWriteGuide from 'containers/ModalManager/Modals/ModalWriteGuide'
import { Controller, useFormContext } from 'react-hook-form'
import { MedicalRecordFormData } from '../../medicalRecordSchema'

export function PatientCaseDescription(): JSX.Element {
  const [isVisibleModalWriteGuide, setIsVisibleModalWriteGuide] = useState(
    false
  )

  const { control, watch } = useFormContext<MedicalRecordFormData>()
  const patientCaseValue = watch('patient_case_description')

  const handleIsVisibleModalWriteGuide = (isVisible: boolean) => () => {
    setIsVisibleModalWriteGuide(isVisible)
  }

  return (
    <S.PatientCaseDescriptionContainer>
      <S.ContentLabel>
        <Typography weight='bolder' variant='content2'>
          Breve descrição e indicação clínica *
        </Typography>
        <IconHelp onClick={handleIsVisibleModalWriteGuide(true)} />
      </S.ContentLabel>
      <Typography variant='content3'>
        Lembre-se: será vista por outros profissionais da saúde e pelo paciente,
        caso ele requisite seu prontuário.
      </Typography>
      <Controller
        name='patient_case_description'
        control={control}
        render={({ field, fieldState: { error } }) => {
          const hasError = Boolean(error?.message)
          return (
            <TextBox
              {...field}
              placeholder='Digite aqui'
              maxLength={1000}
              hasError={hasError}
              messageError={error?.message}
            />
          )
        }}
      />
      <S.TextAreaLengthDisplay>
        <Typography variant='content3'>
          {patientCaseValue?.length || 0}/1000
        </Typography>
      </S.TextAreaLengthDisplay>
      {isVisibleModalWriteGuide && (
        <ModalWriteGuide onClose={handleIsVisibleModalWriteGuide(false)} />
      )}
    </S.PatientCaseDescriptionContainer>
  )
}
